module.exports = __webpack_public_path__ + "img/noteboy.70c159a1.png";